module.exports = "/images/reserved-4-year-seller.png?05f1df03f2b705b9ddc4b2390e7da5f5";